<template>
  <pilot-dialog :title="$t('selectPilot')">
    <template #header-right>
      <button
        v-tooltip.bottom="{
          content: $t('close')
        }"
        class="pilot-tooltip-btn"
        @click="close"
      >
        <i class="isif isif-close" />
      </button>
    </template>
    <template #body>
      <div class="pilot-tours">
        <div class="pilot-tours__title">
          {{ $t('pilotPopularTours') }}
        </div>
        <div
          v-horizontal-drag-scrolling="{
            startX: contentStartX,
            scrollLeft: contentScrollLeft,
            isMousedown: isContentMousedown
          }"
          class="pilot-tours__content"
        >
          <div
            v-for="item in pilotTours"
            :key="item.objectId"
            class="pilot-tour-card"
            :class="{ 'pilot-tour-card--active': item.objectId === tourId && isPilotPlaying }"
          >
            <div
              class="pilot-tour-card__thumbnail"
              @click="toPilotTour(item.objectId)"
            >
              <img
                v-if="item.pilotThumbnail || item.buildingThumbnail"
                :src="item.pilotThumbnail || item.buildingThumbnail"
              >
              <i
                v-else
                class="isif isif-man"
              />
            </div>
            <div class="pilot-tour-card__body">
              <div class="title">
                {{ item.name }}
              </div>
              <div class="subtitle">
                {{ item.ownerName }}
              </div>
            </div>
            <button
              class="pilot-tour-card__control-btn"
              @click="togglePilotPlayerStatus(item.objectId)"
            >
              <i
                class="isif isif-pilot-play"
                :class="{
                  'isif-pilot-pause': isPilotPlaying && item.objectId === tourId,
                }"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="pilot-influencers">
        <div class="pilot-influencers__title">
          {{ $t('pilotInfluencerList') }}
        </div>
        <div class="pilot-influencers__content">
          <div
            v-for="item in pilotInfluencers"
            :key="item.id"
            class="pilot-influencer-card"
            @click="toPilotInfluencer(item.id)"
          >
            <div class="pilot-influencer-card__avatar">
              <img
                v-if="item.portraitImage"
                :src="item.portraitImage"
              >
              <i
                v-else
                class="isif isif-man"
              />
            </div>
            <div class="pilot-influencer-card__title">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </pilot-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import PilotDialog from './PilotDialog'

export default {
  name: 'PilotMenu',
  components: {
    PilotDialog
  },
  props: {
    pilotTours: {
      type: Array,
      default () {
        return []
      }
    },
    pilotInfluencers: {
      type: Array,
      default () {
        return []
      }
    },
    tourId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      contentStartX: 0,
      contentScrollLeft: 0,
      isContentMousedown: false
    }
  },
  computed: {
    ...mapGetters([
      'isPilotPlaying'
    ])
  },
  methods: {
    toPilotTour (tourId) {
      this.$emit('select-tour', tourId)
      this.$emit('show-player')
    },
    toPilotInfluencer (influencerId) {
      this.$emit('change-page', 'pilot-influencer')
      this.$emit('select-influencer', influencerId)
    },
    close () {
      this.$emit('close', 'pilot-menu')
    },
    togglePilotPlayerStatus (tourId) {
      if (this.isPilotPlaying && this.tourId === tourId) {
        this.$emit('toggle-pilot-player-status')
      } else {
        this.$emit('select-tour', tourId)
        this.$emit('show-player')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './style'

.pilot-influencers {
  width: 100%

  &__title {
    font-weight: 400
    font-size: 14px
    color: $white
  }

  &__content {
    margin-top: 16px
    /* Displays a little more than 2 at most. */
    max-height: calc(2 * (70px + 10px + 16px))
    overflow-y: auto
    padding-right: 8px;
    scrollbars(5px, #ccc, transparent)
    display: flex
    flex-direction: column
    gap: 16px
  }
}

.pilot-influencer-card {
  background-color: #454545
  height: 70px
  width: 100%
  border-radius: 8px
  padding: 10px
  display: flex
  align-items: center
  cursor: pointer

  &__avatar {
    margin-right: 16px

    img {
      width: 50px
      height: 50px
      border-radius: 50%
      object-fit: cover
    }

    i {
      background-color: $white
      border-radius: 50%
      font-size: 50px
    }
  }

  &__title {
    color: $white
    font-weight: 700
    font-size: 16px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  }
}

.pilot-tours__content{
  padding-bottom: 10px;
  scrollbars(5px, #ccc, transparent)
}

</style>
